<script setup>
import { ref, inject, watch } from 'vue';
import { 
	apiAjouterRoutine } from '@/services/ServiceModele.js';
import { normerNom, TypeNommage } from '@/scripts/global.js';
import { 
    getErreurNomNorme,
    getErreurTexteRequis } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['editionArguments']);

const appelerApiModifModele = inject('appelerApiModifModele');
const selectionnerRoutine = inject('selectionnerRoutine');
const afficherSucces = inject('afficherSucces');

const nouvelleRoutine = ref(getRoutineInitiale());

watch(() => visible.value, (visible) => {
    if (visible) {
        nouvelleRoutine.value = getRoutineInitiale();
    }
})

watch(() => nouvelleRoutine.value.libelle, (nouveauLibelle, ancienLibelle) => {
    if (!nouvelleRoutine.value.nom || nouvelleRoutine.value.nom === normerNom(ancienLibelle, TypeNommage.VARIABLE)) {
        nouvelleRoutine.value.nom = normerNom(nouveauLibelle, TypeNommage.VARIABLE);
    }
});

function getRoutineInitiale() {
    return {
        nom: null,
        libelle: null
    };
}

function validerSaisie(routine) {
    const erreurs = {};
    erreurs.nom = getErreurNomNorme(routine.nom, TypeNommage.VARIABLE);
    erreurs.libelle = getErreurTexteRequis(routine.libelle);
    return erreurs;
}

function validerFormulaire() {
    nouvelleRoutine.value.validationFormulaire = true;
}

function ajouterRoutine() {
    appelerApiModifModele(apiAjouterRoutine, nouvelleRoutine.value, (reponseOK) => {
        if (reponseOK) {
            selectionnerRoutine(nouvelleRoutine.value.nom);
            emit('editionArguments', true);
            visible.value = false;
            afficherSucces('Routine créée');
        }
    });
}

</script>

<template>
    <Dialog 
    v-model:visible="visible"
    :modal="true">
        <template #header>
            <label class="titre">Ajout d'une routine</label>
        </template>
        <Formulaire
            :objet="nouvelleRoutine"
            :fonction-validation-saisie="validerSaisie"
            @validation="ajouterRoutine">
            <label class="intitule">Libellé :</label>
            <SaisieTexte v-model:valeur="nouvelleRoutine.libelle" :id-erreur="'libelle'" :autofocus="true" />
            <label class="intitule">Nom :</label>
            <SaisieTexte v-model:valeur="nouvelleRoutine.nom" :id-erreur="'nom'" />
        </Formulaire>
        <template #footer>
            <button 
                class="bouton btn-primaire fas fa-check" 
                @click="validerFormulaire()"/>
        </template>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

</style>